import React from "react";
import { Card } from "react-bootstrap";
import { UseFormReturn, useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { OrganizationAccessApi } from "../../../../../../../../../services/Api/Admin/adminTypes";
import { OrganizationApplicationAccessApi } from "../../../../../../../../../services/Api/types";

interface Props {
	form: UseFormReturn<OrganizationAccessApi>;
	applicationIndex?: number;
	accesses?: OrganizationApplicationAccessApi[];
	header: string;
}

const OrganizationSingleAccessForm = ({ form, applicationIndex, accesses, header }: Props) => {
	const fieldsName: "accesses" | `applications.${number}.accesses` =
		applicationIndex !== undefined ? `applications.${applicationIndex}.accesses` : "accesses";
	const { t } = useTranslation("admin");
	const {
		formState: { errors },
		control,
		register,
		watch,
	} = form;
	const { fields } = useFieldArray({
		control,
		name: fieldsName,
		keyName: "key",
	});
	const watchedItems = watch(fieldsName);
	const types = [
		{
			label: "Tak",
			value: "true",
		},
		{
			label: "Nie",
			value: "false",
		},
		{
			label: "-",
			value: "",
		},
	];

	const getAccessDefaultValue = (item: OrganizationApplicationAccessApi) =>
		accesses?.find((access) => access.type === item.type)?.value ?? "-";

	if (watchedItems.length === 0) return <></>;

	return (
		<Card>
			<Card.Header>{header}</Card.Header>
			<Card.Body>
				<div className="row row-gap-4">
					{watchedItems.map((item, index) => {
						return (
							<div key={fields[index].key} className="col-md-3">
								<div className="d-flex mb-1">
									<p className="mb-0">{`${t(
										"modules.organization.field.default_value.title"
									)} ${getAccessDefaultValue(item)}`}</p>
								</div>
								{item.type.includes("_ENABLED") ? (
									<FormSelectGroup
										label={item.type}
										name={`${fieldsName}.${index}.custom_value`}
										defaultValue={item.custom_value}
										errors={errors}
										options={types}
										control={control}
										data-testid={`${fieldsName}.${index}.custom_value`}
									/>
								) : (
									<FormInput
										register={register}
										label={item.type}
										name={`${fieldsName}.${index}.custom_value`}
										errors={errors}
									/>
								)}
							</div>
						);
					})}
				</div>
			</Card.Body>
		</Card>
	);
};

export default OrganizationSingleAccessForm;
